import { Component, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import * as _ from 'lodash';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
/**Service file */
import { ArchivedOrdersServiceService } from './archived-orders-service.service';
import { EcommerceOrderService } from '../../../../../order/order.service';
/** Local file */
import { displayValues, toastMsg } from '../../../../../../utils/index';
// Local component
import { FuseConfirmDialogComponent } from '../../../../../../../../../core/components/confirm-dialog/confirm-dialog.component';
import { ToastComponent } from '../../../../../../common/toast.component';
import { CommonQueryService } from '../../../../../../queryFiles';
import { AuditHistoryService } from '../../../../../../../../../core/services/audit-history.service';
import { catchError, map, startWith, switchMap } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

@Component({
  selector: 'app-archived-orders-list',
  templateUrl: './archived-orders-list.component.html',
  styleUrls: ['./archived-orders-list.component.scss']
})
export class ArchivedOrdersListComponent implements OnInit {

  toastMsg = toastMsg;
  displayValues = displayValues;
  public allArchivedOrders: any = [];
  public orderCount: number = 0;
  currentPageIndex: number = 0;
  pageSize: number = 100;
  displayedColumns = ['customer', 'contact', 'propertyAdd', 'product', 'date', 'dueDate', 'agentRole', 'clientRole', 'clientName', 'unArchive'];
  archivedOrdersSource: MatTableDataSource<ArchivedOrdersData>;
  @ViewChild(MatPaginator) archivedOrdersPaginator: MatPaginator;
  @ViewChild(MatSort) archivedOrderssort: MatSort;
  confirmDialogRef: any;
  selectedId: any;
  previousLoad: number = 100; // previous loaded count in items per page
  previousIndex: number = -1;
  resultLength: number = 0;
  isRateLimitReached = false;
  isLoadingResults = true;
  private _subscriptions: Subscription[] = [];
  dialogRef: any;

  constructor(
    public dialog: MatDialog,
    // Service file
    private archivedOrdersServiceService: ArchivedOrdersServiceService,
    public commonQueryService: CommonQueryService,
    /** Local component */
    public toastComponent: ToastComponent,
    public auditHistoryService: AuditHistoryService,
  ) { }

  ngOnInit() {
    // this.isLoadingResults = true;
    // this.archivedOrdersServiceService.getAllArchivedOrders().then((archivedOrders) => {
    //   this.allArchivedOrders = archivedOrders && archivedOrders.length > 0 ? archivedOrders : [];
    //   this.loadResult();
    // }).catch((err) => {
    //   console.log("error in get archived orders List ", err);
    //   this.allArchivedOrders = [];
    // })

  }

  ngOnDstroy() { }

  ngAfterViewInit() {

    // if (this.archivedOrdersSource) {
    //   this.archivedOrdersSource.paginator = this.archivedOrdersPaginator;
    //   this.archivedOrdersSource.sort = this.archivedOrderssort;
    // }

    this.listArchiveOrders();


  }

  loadResult() {

    this.allArchivedOrders = _.uniqBy(this.allArchivedOrders, 'id');
    this.archivedOrdersServiceService.checkDocProcess(this.allArchivedOrders).then((processedOrder) => {
      this.allArchivedOrders = processedOrder;
      this.assignDataSource(processedOrder);
    }).catch((err) => {
      console.log("error in get archived orders load ", err);
      this.allArchivedOrders = [];
      this.assignDataSource([]);
    });

  }

  assignDataSource(orders) {

    this.archivedOrdersSource = new MatTableDataSource(orders);
    this.archivedOrdersSource.paginator = this.archivedOrdersPaginator;
    this.archivedOrdersSource.sort = this.archivedOrderssort;
    this.orderCount = this.allArchivedOrders.length;
    this.isLoadingResults = false;
    this.highLightFirstRow();
  }

  /** Archive order */
  unArchiveOrder(order) {
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: false
    });
    let auditParams = {
      id: order && order.id ? order.id : null,
      archive: 'null'
    }
    this.confirmDialogRef.componentInstance.confirmMessage = this.toastMsg.unArchiveConfirm;
    this.confirmDialogRef.componentInstance.confirmHead = this.toastMsg.unArchiveHead;
    this.confirmDialogRef.componentInstance.confirmOkText = this.toastMsg.unArchiveOk;
    this.confirmDialogRef.componentInstance.confirmCancelText = this.toastMsg.unArchiveCancel;

    this.confirmDialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.isLoadingResults = true;
        _.remove(this.allArchivedOrders, { id: order.id }) //remove that order
        this.assignDataSource(this.allArchivedOrders);
        //fetch node id from db for corrspodding order
        // this.commonQueryService.FETCH_ORDER_BY_ID(order.id).valueChanges.subscribe((res) => {
        //   console.log("unArchiveOrder res")

        //   if (res && res.data.allOrders && res.data.allOrders.nodes.length > 0) {
        //     let orderRecord = res.data.allOrders.nodes[0];
        //update the aricve status in db
        this.commonQueryService.UPDATE_ORDER_BY_ID(auditParams.id, null).subscribe((res: any) => {
          this.auditHistoryFunCall("Success", auditParams)
          this.showToast('success');
        }, error => {
          this.auditHistoryFunCall("Failed", auditParams)

          this.isLoadingResults = false;
        });
        // }
        // }, error => {
        //   this.auditHistoryFunCall("Failed", auditParams)

        //   this.isLoadingResults = false;
        // });
      }

    })

  }

  //Show toast message
  showToast(message) {

    this.toastComponent.showToast(message == 'success' ?
      this.toastMsg.unArchiveSuccess :
      this.toastMsg.unArchiveFailed);
  }

  /**Initially  Highlight first row */
  highLightFirstRow() {
    (this.currentPageIndex == 0 && this.allArchivedOrders.length > 0) ?
      this.selectedId = this.allArchivedOrders[0].id : '';
  }

  /** Based on row select- Highlight row */
  onSelect(selected) {
    this.selectedId = selected.id;
  }


  auditHistoryFunCall(status, newData) {

    let auditLogPayload = {
      roleId: window.localStorage.getItem('roleId'),
      userId: window.localStorage.getItem('userUID'),
      orderId: newData && newData.id ? newData.id : null,
      newData: newData,
      oldData: null,
      auditType: 'unarchive',
      logsDesc: "unarchived",
      platform: "Executive Dashboard",
      status: status,
      createdAt: "now()"
    };
    console.log("auditLogPayload", auditLogPayload)
    this.auditHistoryService.auditHistoryForCreateOrDeleteCall(auditLogPayload);
  }

  listArchiveOrders() {
    this.allArchivedOrders = [];
    this.previousIndex = -1;
    this.isLoadingResults = true;
    this.archivedOrdersPaginator.page
      .pipe(
        startWith({}),
        switchMap(() => {
          this.isLoadingResults = true;
          this.isRateLimitReached = false;

          this.setPreviousIndex(this.archivedOrdersPaginator.pageSize);

          var offset = this.archivedOrdersPaginator.pageIndex * this.archivedOrdersPaginator.pageSize;

          let payload = {
            first: this.archivedOrdersPaginator.pageSize,
            offset: offset,
          };
          console.log("payload", payload);
          if (this.previousIndex < this.archivedOrdersPaginator.pageIndex) {
            return this.archivedOrdersServiceService.getAllArchivedOrdersLimit(payload);
          }
          else {
            return this.allArchivedOrders;
          }
        }),
        map(
          (data) => {
            this.isLoadingResults = false;
            this.isRateLimitReached = false;

            if (this.previousIndex < this.archivedOrdersPaginator.pageIndex) {
              if (data && (data['nodes'] && data['nodes'].length > 0)) {
                this.previousIndex = this.archivedOrdersPaginator.pageIndex;
                this.setDataFormat(data['nodes']);
                this.resultLength = data['totalCount'];
              }
              else {
                this.isLoadingResults = false;
                this.isRateLimitReached = true;
                this.allArchivedOrders = [];
              }
            }

            else {
              this.resultLength = this.resultLength;
            }
            return this.allArchivedOrders;
          }),
        catchError(() => {
          this.isLoadingResults = false;

          this.isRateLimitReached = true;
          return of([]);
        })
      ).subscribe(data => {
        // this.setTableDataSource(data);
      });
    () => {
      this.isLoadingResults = false;
    }
  }

  setDataFormat(response) {
    console.log("response", response);
    let temp = [];
    // response.forEach((event) => {
    this.archivedOrdersServiceService.checkDocProcess(response).then((processedOrder) => {
      temp = temp.concat(processedOrder)
      if (response.length == temp.length) {
        this.allArchivedOrders = _.uniqBy(this.allArchivedOrders, 'id');
        this.allArchivedOrders = this.allArchivedOrders.concat(temp);
        this.setTableDataSource(this.allArchivedOrders);
      }
    }).catch((err) => {
      console.log("error in get archived orders load ", err);
      this.allArchivedOrders = [];
      this.assignDataSource([]);
    });
    // })
  }

  setTableDataSource(data) {
    this.archivedOrdersSource = new MatTableDataSource(data);
    setTimeout(() => this.archivedOrdersPaginator.length = this.resultLength);
    this.archivedOrdersSource.paginator = this.archivedOrdersPaginator;
    this.archivedOrdersSource.sort = this.archivedOrderssort;
    this.isLoadingResults = false;
  }

  setPreviousIndex(pageSize: number) {

    if (this.previousLoad != pageSize) {
      this.previousLoad = pageSize; // resetting page size
      if (this.allArchivedOrders.length > pageSize) {
        this.previousIndex = Math.ceil((this.allArchivedOrders.length / pageSize)) - 1; //setting previous index as per page size
      }
      else {
        this.previousIndex = Math.round((this.allArchivedOrders.length / pageSize)) - 1; //setting previous index as per page size
      }

      if (this.previousIndex == -1) {
        this.allArchivedOrders = []; //if paginator is first page - then set products array empty
      }
    }

  }


}
export interface ArchivedOrdersData {

  name: string,
  email: string,
  address: string;
  orderDate: string;
  dueDate: string;
  agentRole: string;
  agentName: string;
  clientRole: string;
  clientName: string;
}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/orders/sidenavs/left/operations/archived-orders-list/archived-orders-list.component.ts